import { createSlice } from "@reduxjs/toolkit";

const initialPMSSlice = {
        pms: {
                isLoading: false,
                success: false,
                error: '',
                list: [],
                totalpending: 0
        },
        dropDownSource: {
                tanks: [],
                movementtype: []
        }
};

export const PMSSlice = createSlice({
        name: "pms",
        initialState: initialPMSSlice,
        reducers: { 
                StartGettingAllPMS: (state, action) => {
                        state.pms = {
                                isLoading: true,
                                success: false,
                                error: '',
                                list: [],
                                totalpending: 0
                        }
                }, 
                SetPMSList: (state, action) => {
                        state.pms = {
                                isLoading: false,
                                success: action.payload.success,
                                error: action.payload.error,
                                list: action.payload.list,
                                totalpending: action.payload.totalpending
                        }
                },
                ResetPMWList: (state, action) => {
                        state.pms = initialPMSSlice.pms;
                },
                SetAllDropDownOptions: (state, action) => {
                        state.dropDownSource = {
                                tanks: action.payload.tanks,
                                movementtype: action.payload.movementtype
                        }
                }
                 
        }
});